import { useGetStudioDetails } from '~entities/studios/api/get-studio-details';

/** Studio Portal V2 enrollment/family IA (ENR-4054 hub). False for classic V1. */
export const useIsStudioV2 = (): {
  isV2: boolean;
  isLoading: boolean;
} => {
  const { data, isLoading } = useGetStudioDetails();
  return {
    isV2: data?.isV2 === true,
    isLoading,
  };
};
